import {createReducer} from '@reduxjs/toolkit';

import {setOmniChannelsVoucherRedemptionEnabled} from 'store/actions/app-action';
import {
  setBasketDetailsAction,
  setIsLoadingAction,
  setIsBasketApiFailedAction,
  setSelectedItemsAction,
  setBasketPromotionsLiteAction,
  setBasketPromotionsLiteLoadingAction,
  setBasketQuantityChangedProductMapAction,
  setVariantIdsOfItemThatWasAdjustedQuantityAction,
  setRM3PromotionsAction
} from 'store/actions/basket-action';
import {ReduxBasketState} from 'types';

const initialState: ReduxBasketState = {
  basket: undefined,
  isLoading: false,
  isBasketApiFailed: false,
  selected1pSections: [],
  selected3pSections: [],
  selectedItems: [],
  promotions: {
    isLoading: false,
    skuBasedPromotions: [],
    promotionSuggestions: [],
    estimatedPointsReceive: 0,
    estimatedPointsDetails: []
  },
  basketQuantityChangedProductMap: {},
  variantIdsOfItemThatWasAdjustedQuantity: [],
  unavailableItems: [],
  basketItems: [],
  rm3Promotions: {},
  newBaksetItem: '',
  omniChannelsVoucherRedemptionEnabled: false
};

const BasketReducer = createReducer(initialState, (builder) => {
  builder.addCase(setBasketDetailsAction, (state, action) => {
    return {
      ...state,
      basket: action?.payload || {}
    };
  });

  builder.addCase(setIsLoadingAction, (state, action) => {
    return {
      ...state,
      isLoading: action?.payload
    };
  });

  builder.addCase(setIsBasketApiFailedAction, (state, action) => {
    return {
      ...state,
      isBasketApiFailed: action?.payload
    };
  });

  builder.addCase(setSelectedItemsAction, (state, action) => {
    return {
      ...state,
      selectedItems: action?.payload
    };
  });

  builder.addCase(setBasketPromotionsLiteLoadingAction, (state, action) => {
    return {
      ...state,
      promotions: {
        ...state?.promotions,
        isLoading: action.payload
      }
    };
  });

  builder.addCase(setRM3PromotionsAction, (state, action) => {
    return {
      ...state,
      rm3Promotions: {
        ...state.rm3Promotions,
        ...action.payload
      }
    };
  });

  builder.addCase(setBasketPromotionsLiteAction, (state, action) => {
    return {
      ...state,
      promotions: {
        ...state.promotions,
        ...action?.payload
      }
    };
  });

  builder.addCase(setBasketQuantityChangedProductMapAction, (state, action) => {
    return {
      ...state,
      basketQuantityChangedProductMap: action.payload
    };
  });

  builder.addCase(setVariantIdsOfItemThatWasAdjustedQuantityAction, (state, action) => {
    return {
      ...state,
      variantIdsOfItemThatWasAdjustedQuantity: action.payload
    };
  });

  builder.addCase(setOmniChannelsVoucherRedemptionEnabled, (state, action) => {
    return {
      ...state,
      omniChannelsVoucherRedemptionEnabled: action?.payload || false
    };
  });
});

export default BasketReducer;
